{
  "name": "best-consultant",
  "version": "0.8.569",
  "type": "module",
  "scripts": {
    "start": "node index.js",
    "dev": "vp dev",
    "dev-open": "vp dev --host",
    "build": "cross-env NODE_ENV=production vp build",
    "preview-https": "cross-env PORT=8443 serve dist",
    "serve": "vp preview"
  },
  "dependencies": {
    "@bc-library/common": "workspace:*",
    "@bc-library/emailing": "workspace:*",
    "@bc-library/evaluation": "workspace:*",
    "@bc-library/interface": "workspace:*",
    "@bc-library/leave": "workspace:*",
    "@bc-library/project": "workspace:*",
    "@bc-library/recruitment": "workspace:*",
    "@bc-library/resource": "workspace:*",
    "@bc-library/timesheet": "workspace:*",
    "@bc-library/training": "workspace:*",
    "@bc-library/translation": "workspace:*",
    "@comark/vue": "^0.6.1",
    "@faker-js/faker": "^8.0.1",
    "@floating-ui/dom": "^1.6.0",
    "@floating-ui/vue": "^1.1.10",
    "@formkit/auto-animate": "1.0.0-beta.6",
    "@formkit/drag-and-drop": "^0.5.3",
    "@iconify/json": "^2.2.437",
    "@internationalized/date": "^3.5.6",
    "@internationalized/number": "^3.6.0",
    "@intlify/unplugin-vue-i18n": "^11.2.5",
    "@number-flow/vue": "^0.4.8",
    "@openreplay/tracker": "^18.0.6",
    "@openreplay/tracker-assist": "^11.0.12",
    "@popperjs/core": "^2.11.8",
    "@tailwindcss/typography": "^0.5.20",
    "@tailwindcss/vite": "^4.3.3",
    "@tato30/vue-pdf": "^1.11.5",
    "@tiptap/core": "^3.27.0",
    "@tiptap/extension-bubble-menu": "^3.27.0",
    "@tiptap/extension-collaboration": "^3.27.0",
    "@tiptap/extension-collaboration-caret": "^3.27.0",
    "@tiptap/extension-drag-handle": "3.27.0",
    "@tiptap/extension-drag-handle-vue-3": "3.27.0",
    "@tiptap/extension-highlight": "^3.27.0",
    "@tiptap/extension-image": "^3.27.0",
    "@tiptap/extension-link": "^3.27.0",
    "@tiptap/extension-list": "^3.27.0",
    "@tiptap/extension-mention": "^3.27.0",
    "@tiptap/extension-node-range": "3.27.0",
    "@tiptap/extension-subscript": "^3.27.3",
    "@tiptap/extension-superscript": "^3.27.3",
    "@tiptap/extension-table": "^3.27.0",
    "@tiptap/extension-text-align": "^3.27.0",
    "@tiptap/extension-text-style": "^3.27.0",
    "@tiptap/extension-underline": "^3.27.3",
    "@tiptap/extensions": "^3.27.0",
    "@tiptap/pm": "^3.27.0",
    "@tiptap/starter-kit": "^3.27.0",
    "@tiptap/suggestion": "^3.27.0",
    "@tiptap/vue-3": "^3.27.0",
    "@tiptap/y-tiptap": "^3.0.6",
    "@u22n/mailtools": "^0.1.2",
    "@unhead/vue": "^1.10.4",
    "@vitejs/plugin-vue": "^6.0.7",
    "@vue-pdf-viewer/viewer": "^3.6.2",
    "@vue-player/vue": "^0.1.6",
    "@vue/compiler-sfc": "^3.6.0-rc.2",
    "@vuepic/vue-datepicker": "^5.1.2",
    "@vueuse/components": "^11.0.3",
    "@vueuse/core": "^11.0.3",
    "@vueuse/head": "^2.0.0",
    "@vueuse/integrations": "^11.0.3",
    "@xyflow/vue": "2.0.0-next.1",
    "animate.css": "^4.1.1",
    "animejs": "^3.2.2",
    "axios": "^1.7.7",
    "canvas-confetti": "^1.9.3",
    "color-convert": "^2.0.1",
    "comark": "^0.6.1",
    "connect-history-api-fallback": "^2.0.0",
    "cors": "^2.8.5",
    "cropperjs": "^2.0.0-beta.4",
    "cross-env": "^7.0.3",
    "date-fns": "^3.1.1",
    "dayjs": "^1.11.7",
    "dotenv": "^16.0.3",
    "echarts": "^6.0.0",
    "express": "^4.18.2",
    "floating-vue": "^5.2.2",
    "fuse.js": "^6.6.2",
    "jszip": "^3.10.1",
    "jwt-decode": "^4",
    "litepie-datepicker": "^1.0.14",
    "markdown-it": "^14.1.0",
    "maska": "^2.1.10",
    "motion": "^12.23.24",
    "motion-v": "^2.3.0",
    "pdfjs-dist": "5.4.296",
    "pinia": "^2.3.0",
    "pinia-plugin-persistedstate": "^4.2.0",
    "postcss": "^8.4.32",
    "qrcode": "^1.5.4",
    "reka-ui": "^2.9.1",
    "rfdc": "^1.4.1",
    "sass": "^1.55.0",
    "tailwindcss": "^4.3.3",
    "typescript": "^5.5.4",
    "unplugin-fonts": "^1.1.1",
    "unplugin-icons": "^23.0.1",
    "v-calendar": "^3.1.2",
    "vee-validate": "^4.7.0",
    "vite": "catalog:",
    "vite-plugin-markdown": "^3.0.0-2",
    "vite-plugin-vue-devtools": "^8.0.7",
    "vite-svg-loader": "^5.1.0",
    "vue": "^3.6.0-rc.2",
    "vue-advanced-cropper": "^2.8.9",
    "vue-confetti-explosion": "^1.0.2",
    "vue-echarts": "^8.0.1",
    "vue-i18n": "^11.1.12",
    "vue-router": "^4.4.3",
    "vue-virtual-scroller": "3.0.4",
    "y-websocket": "^2.1.0",
    "yjs": "^13.6.10",
    "yup": "^1.1.1",
    "zod": "^4.1.13"
  },
  "devDependencies": {
    "@inspira-ui/plugins": "^0.0.1",
    "@vue/typescript-plugin": "^3.3.4",
    "class-variance-authority": "^0.7.1",
    "clsx": "^2.1.1",
    "vite-plus": "catalog:"
  }
}
